export default __webpack_public_path__ + "static/media/logos.4029eea1.png";